module.exports = "<div class=\"app no-padder\" ng-class=\"$ctrl.appClass\" style=\"background-color: white\"><navbar settings=\"$ctrl.app.settings\" ng-if=\"!$ctrl.$state.includes(&quot;oauth&quot;)\"></navbar><div class=\"content\"><a class=\"off-screen-toggle hide\" href=\"\"></a><div class=\"app-content-body no-padder\" ui-view=\"\"></div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.pug
// module id = 12
// module chunks = 0